import styled from 'styled-components';
import { StyledStationTitleLink } from '../StationSummaryCardV2/StationListSummaryCard.styles';

export const StyledStationLink = styled(StyledStationTitleLink)<{ justifyContent?: string }>`
  span {
    display: flex;
    align-items: center;
    justify-content: ${(props) => (props.justifyContent ? props.justifyContent : '')};
    gap: var(--allie-spacing-md);
  }
`;
